<!-- 题库列表 -->
<template>
<div class="qbListBox" v-if="init">
    <pull :pull="pull" :page="page" @getList="getList">
        <div class="qbList">
            <!-- 专题 -->
            <div class="topicItem" @click="handleGoTopicList('jjcy')">
                <img class="topicCoverurl" src="https://img.capwhale.com/qb/logo_jjcy.png" alt="">
            </div>
            <div class="topicItem" @click="handleGoTopicList('zqcy')">
                <img class="topicCoverurl" src="https://img.capwhale.com/qb/logo_zqcy.png" alt="">
            </div>
            <!-- 题库列表 -->
            <div class="list">
                <div class="qbItem" @click="handleGoQbDetails(item)" v-for="(item, index) in dataList" :key="index">
                    <img :src="item.coverurl" class="coverurl" alt="">
                    <div class="subject text-ellipses">{{ item.subject }}</div>
                </div>
            </div>
        </div>
    </pull>
</div>
</template>

<script>
import Pull from 'views/mobile/components/pull/pull'
import {mapActions, mapGetters} from 'vuex'
import {getQuestionbankByKey} from 'api/searchApi'
export default {
    data() {
        return {
            init: false,
            dataList: [],
            param: {
                key: '',
                catecode: ''
            },
            page: {
                page: 1,
                pagesize: 20,
                pageCount: 0,
                rowCount: 0
            },
            pull: {
                isLoading: false,
                loading: false,
                error: false,
                finished: false
            },
        }
    },
    // 生命周期 - 创建完成（访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（访问DOM元素）
    mounted() {
        this.getList()
    },
    activated() {
        if (this.refresh) {
            this.getList()
            this.setRefresh(false)
        }
    },
    methods: {
        getList() {
            this.setLoading(true)
            getQuestionbankByKey({
                data: Object.assign({}, this.param, this.page),
                success: data => {
                    this.init = true
                    if (this.page.page === 1) {
                        this.pull.isLoading = false
                        this.dataList = data.data.banklist
                    } else {
                        this.dataList = this.dataList.concat(data.data.banklist)
                    }
                    this.setLoading(false)
                    this.pull.loading = false
                    this.page.pageCount = data.data.pageinfo.pageCount
                    this.page.rowCount = data.data.pageinfo.rowCount
                    if (this.page.page === this.page.pageCount) {
                        this.pull.finished = true
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.pull.error = true
                    this.pull.loading = false
                    this.$toast.fail(data.msg)
                }
            })
        },
        handleGoTopicList(code) {
            this.$router.push({
                name: 'QuestionList',
                query: {
                    code: code
                }
            })
        },
        handleGoQbDetails(item) {
            this.setRefresh(true)
            this.$router.push({
                name: 'PaperDetails',
                query: {
                    qid: item.innerid
                }
            })
        },
        ...mapActions(['setLoading', 'setRefresh', 'setNoDataTip'])
    },
    computed: {
        ...mapGetters(['refresh'])
    },
    components: {
        Pull
    }
}
</script>
<style lang='scss'>
/* @import url(); 引入css类 */
.qbListBox {
    .qbList {
        padding: 0.28rem 0.32rem 0 0.32rem;
        .topicItem {
            margin-bottom: 0.28rem;
            .topicCoverurl {
                width: 100%;
                height: 3.84rem;
            }
        }
        .list {
            display: flex;
            flex-wrap: wrap;
            align-items: stretch;
            .qbItem {
                width: calc((100% - 0.2rem) / 2);
                margin-bottom: 0.28rem;
                &:not(:nth-of-type(even)) {
                    margin-right: 0.2rem
                }
                .coverurl {
                    width: 100%;
                    height: 1.86rem;
                    border-radius: 0.1rem;
                    margin-bottom: 0.2rem;
                }
                .subject {
                    font-size: 0.3rem;
                    color: #333333;
                    line-height: 0.42rem;
                }
            }
        }
    }
}
</style>